import { z } from 'zod';

/**
 * RFC 9457 Problem Details as returned by every failed API request (api-design §2).
 * `code` stays a plain string so an older client can still read errors added by a newer server;
 * use `isErrorCode` to narrow it.
 */
export const fieldErrorSchema = z.object({
  path: z.string(),
  message: z.string(),
});

export const problemDetailsSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int().min(400).max(599),
  code: z.string(),
  detail: z.string().optional(),
  requestId: z.string(),
  errors: z.array(fieldErrorSchema).optional(),
  details: z.record(z.string(), z.unknown()).optional(),
});

export type FieldError = z.infer<typeof fieldErrorSchema>;
export type ProblemDetails = z.infer<typeof problemDetailsSchema>;

export const PROBLEM_CONTENT_TYPE = 'application/problem+json';
